import React from 'react';
import LocationTemplate from './LocationTemplate';

const TarboroPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Tarboro"
      stateName="North Carolina"
      countyName="Edgecombe"
      zipCodes={["27886"]}
      latitude={35.8968}
      longitude={-77.5358}
      population={10721}
      historicalFact="Established in 1760, has a 45-block historic district with many antebellum homes."
      nearbyTowns={[
        "Rocky Mount, NC",
        "Wilson, NC",
        "Greenville, NC",
        "Nashville, NC",
        "Battleboro, NC",
        "Elm City, NC",
        "Pinetops, NC",
        "Macclesfield, NC"
      ]}
    />
  );
};

export default TarboroPage;